export default __webpack_public_path__ + "static/media/h_icon3.740d3f61.png";